import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [f, setF] = useState({ new_password: "", confirm: "" });
  const [done, setDone] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const cls = "mt-2 w-full border-b border-[#1c1418]/30 bg-transparent py-3 text-lg outline-none focus:border-[#1c1418]";

  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return setError("Le due password non coincidono");
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/reset-password", { token, new_password: f.new_password });
      setDone({ admin: "/admin", model: "/approved-signcontract" }[data?.role] || "/scout");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main data-testid="reset-password-page" className="flex min-h-screen items-center justify-center bg-white px-5 pt-20 text-[#1c1418]">
      <div className="w-full max-w-md border border-[#1c1418]/20 p-8">
        <h1 className="font-display text-5xl uppercase leading-none">Nuova password</h1>
        {done ? (
          <div className="mt-8 space-y-6" data-testid="reset-password-done">
            <p>Password aggiornata. Ora puoi accedere con la nuova password.</p>
            <Link to={done} data-testid="reset-password-login-link" className="block w-full bg-[#1c1418] py-4 text-center font-mono text-xs uppercase tracking-[0.25em] text-white">Vai all'accesso</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-6">
            {[["new_password", "Nuova password (min 8)"], ["confirm", "Ripeti nuova password"]].map(([k, l]) => (
              <label key={k} className="block font-mono text-[11px] uppercase tracking-[0.25em] text-[#1c1418]/70">{l}
                <input type="password" required minLength={8} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })}
                  data-testid={`reset-password-${k}`} className={cls} />
              </label>
            ))}
            {error && <p data-testid="reset-password-error" className="text-sm">{error}</p>}
            <button disabled={busy || !token} data-testid="reset-password-submit" className="w-full bg-[#1c1418] py-4 font-mono text-xs uppercase tracking-[0.25em] text-white disabled:opacity-60">
              {busy ? "Salvataggio…" : "Salva nuova password"}
            </button>
          </form>
        )}
      </div>
    </main>
  );
}
